import { SET_BILLING_PRODUCTS_DATA, SET_BILLING_MEMBERSHIP_DATA, SET_BILLING_PACKAGE_DATA, SET_BILLING_SERVICES_DATA, SET_PAYMENT_METHOD__DATA, SET_CLIENT_INFO, SET_SERVICE_INFO, SET_BILL_SUMMARY, SET_BILLING__DATA, SET_NO_GST__DATA, SET_UNPAID_AMT_DATA, SET_SURVEY_RESPONSE_DATA, SET_PAYMENT_METHOD_RESPONSE__DATA, SET_BILLING_AUTOBILL_DATA } from "../ActionName/ActionName";

const initialState = {
    clientInfo: null,
    selectedServices: [],
    selectedProducts: [],
    selectedMemberships: [],
    selectedPackages: [],
    selectedAutoBills: [],
    billingData: null,
    paymentMethodResponse: null,
    unpaidAmt: null,
    noGst: false,
    billSummary: {
        subTotal: 0,
        taxableAmount: 0,
        GST: 0,
        gstPercentage: 18,
        grandTotal: 0,
        payingNow: 0,
        balanceAmount: 0,
        dueAmount: 0,
        discount: 0,
        discountType: 'percentage',
        discountValue: 0,
        extraCharges: 0,
        adjustPayment: 0,
        couponCode: null,
        notes: null
    },
    paymentMethod: [{ title: "CASH", price: 0 }, { title: "CARD", price: 0 }, { title: "UPI", price: 0 }, { title: "WALLET", price: 0 }],
    timestamp: Date.now()
}
const BillingReducer = (state = initialState, action) => {

    switch (action.type) {
        case SET_BILLING__DATA:
            return ({ ...state, billingData: action.value, timestamp: Date.now() })
        case SET_PAYMENT_METHOD_RESPONSE__DATA:
            return ({ ...state, paymentMethodResponse: action.value, timestamp: Date.now() })
        case SET_UNPAID_AMT_DATA:
            return ({ ...state, unpaidAmt: action.value, timestamp: Date.now() })
        case SET_NO_GST__DATA:
            return ({ ...state, noGst: action.value, timestamp: Date.now() })
        case SET_CLIENT_INFO:
            return ({ ...state, clientInfo: action.value, timestamp: Date.now() })
        case SET_SERVICE_INFO:
            return ({ ...state, selectedServices: action.value, timestamp: Date.now() })
        case SET_BILLING_PRODUCTS_DATA:
            return ({ ...state, selectedProducts: action.value, timestamp: Date.now() })
        case SET_BILLING_MEMBERSHIP_DATA:
            return ({ ...state, selectedMemberships: action.value, timestamp: Date.now() })
        case SET_BILLING_PACKAGE_DATA:
            return ({ ...state, selectedPackages: action.value, timestamp: Date.now() })
        case SET_BILL_SUMMARY:
            return ({ ...state, billSummary: action.value, timestamp: Date.now() })
        case SET_BILLING_SERVICES_DATA:
            return ({ ...state, selectedServices: action.value, timestamp: Date.now() })
        case SET_PAYMENT_METHOD__DATA:
            return ({ ...state, paymentMethod: action.value, timestamp: Date.now() })
        case SET_BILLING_AUTOBILL_DATA:
            return ({ ...state, selectedAutoBills: action.value, timestamp: Date.now() })
        default:
            return state;
    }
}

export default BillingReducer;